// import { Injectable } from '@angular/core';
// import {
//   HttpInterceptor,
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpResponse,
//   HttpErrorResponse
// } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { tap } from 'rxjs/operators';
// import { EnvironmentService } from './environment.service';

import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentService } from '../enviroment/environment.service';

// @Injectable({
//   providedIn: 'root',
// })
// export class RestInterceptor implements HttpInterceptor {
//   constructor(private readonly environmentService: EnvironmentService) {}

//   intercept(
//     req: HttpRequest<{}>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     if (
//       this.environmentService.data &&
//       this.environmentService.data.apiUrlHeader &&
//       req.url.indexOf(this.environmentService.data.apiUrl) !== -1
//     ) {
//       req = req.clone({
//         setHeaders: { ...this.getCustomConfig() as any },
//       });
//     }

//     return next.handle(req).pipe(
//       tap(
//         (event: HttpEvent<{}>) => {
//           if (event instanceof HttpResponse) {
//             // do stuff with response if you want
//           }
//         },
//         (err: any) => {
//           if (err instanceof HttpErrorResponse) {
//             return throwError(err);
//           }
//         }
//       )
//     );
//   }

//   private getCustomConfig() {
//     const config = {
//       'x-api-key': this.environmentService.data.apiUrlHeader,
//     };

//     return config;
//   }
// }



export function RestInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) {
  // Inject the current `AuthService` and use it to get an authentication token:
  const environmentService = inject(EnvironmentService);

  if (
    environmentService.data &&
    environmentService.data.apiUrlHeader &&
    req.url.indexOf(environmentService.data.apiUrl) !== -1
  ) {
    req = req.clone({
      setHeaders: {
        ...{
          'x-api-key': environmentService.data.apiUrlHeader,
        },
      },
    });
  }

  // Clone the request to add the authentication header.
  // const newReq = req.clone({
  //   headers: req.headers.append('X-Authentication-Token', authToken),
  // });
  return next(req);
}
